import { ZPlayNetworkService } from "commons";

import {
    CreateAwardRequest, CreateContentListRequest,
    CreateCountryRequest,
    CreateCouponRequest,
    CreateFestivalRequest,
    CreateGenreRequest,
    CreateLanguageRequest,
    CreateSubscriptionRequest,
    CreateTagRequest,
    EditAwardRequest,
    EditCountryRequest,
    EditCouponRequest,
    EditFestivalRequest,
    EditGenreRequest,
    EditLanguageRequest,
    EditTagRequest,
    UpdateContentRequest
} from "models/request";

import { CreateSeriesRequest } from "models/request/create-series-request";
import { EditContentListRequest } from "models/request/edit-content-list-request";
import { MultipartConfirmUploadRequest } from "models/request/multipart-confirm-upload-request";
import { ApproveContentRequest } from "../models/request/approve-content-request";

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export class ContentProducerService {
    public static createContentList = (createListRequest: CreateContentListRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.post(`${API_BASE_URL}/api/backoffice/content-lists/`, createListRequest, callback, errCallback);
    };

    public static getContentListSimplifiedList = (callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/content-lists/only-title`, callback, errCallback);
    };

    public static startContentUpload = (req: any, callback: any, errCallback: any) => {
        ZPlayNetworkService.post(`${API_BASE_URL}/api/backoffice/contents/upload`, req, callback, errCallback);
    };

    public static confirmVODFileUpload = (contentId: any, body: MultipartConfirmUploadRequest | {}, callback: any, errCallback: any) => {
        ZPlayNetworkService.putEmptyResponse(`${API_BASE_URL}/api/backoffice/contents/${contentId}/confirm-upload`, body, callback,
            errCallback);
    };

    public static confirmThumbnailUpload = (contentId: any, callback: any, errCallback: any) => {
        ZPlayNetworkService.putEmptyResponse(`${API_BASE_URL}/api/backoffice/contents/${contentId}/confirm-thumb-upload`, {},
            callback, errCallback);
    };

    public static confirmContentListCoverUpload = (id: any, callback: any, errCallback: any) => {
        ZPlayNetworkService.putEmptyResponse(`${API_BASE_URL}/api/backoffice/content-lists/${id}/confirm-avatar-upload`, {}, callback,
            errCallback);
    };

    public static confirmContentListAvatarUpload = (id: any, callback: any, errCallback: any) => {
        ZPlayNetworkService.putEmptyResponse(`${API_BASE_URL}/api/backoffice/content-lists/${id}/confirm-cover-upload`, {}, callback,
            errCallback);
    };

    public static listContents = (queryParams: Array<[string, any]> | null = null, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/contents/list`, callback, errCallback, queryParams);
    };

    public static getContentList = (queryParams: Array<[string, number]> | null = null, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/content-lists/list`, callback, errCallback, queryParams);
    };

    public static deleteContentList = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.deleteEmptyResponse(`${API_BASE_URL}/api/backoffice/content-lists/${id}`, callback, errCallback);
    };

    public static setMainContent = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.putEmptyResponse(`${API_BASE_URL}/api/backoffice/contents/${id}/main`, {}, callback, errCallback);
    };

    public static updateContent = (id: string, body: UpdateContentRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.put(`${API_BASE_URL}/api/backoffice/contents/update/${id}`, body, callback, errCallback);
    };

    public static updateSeries = (id: string, body: UpdateContentRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.put(`${API_BASE_URL}/api/backoffice/series/${id}`, body, callback, errCallback);
    };

    public static deleteContent = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.deleteEmptyResponse(`${API_BASE_URL}/api/backoffice/contents/${id}`, callback, errCallback);
    }

    public static setLiveOnSFLogic = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.put(`${API_BASE_URL}/api/backoffice/contents/${id}/go-live`, {}, callback, errCallback);
    }

    public static getTagListPaginated = (queryParams: Array<[string, any]> | null = null, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/tag/paginated-list`, callback, errCallback, queryParams);
    }

    public static getTagList = (callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/tag/list`, callback, errCallback);
    }

    public static deleteTag = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.deleteEmptyResponse(`${API_BASE_URL}/api/backoffice/tag/${id}`, callback, errCallback);
    }

    public static createTag = (request: CreateTagRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.post(`${API_BASE_URL}/api/backoffice/tag`, request, callback, errCallback);
    }

    public static editTag = (id: string, request: EditTagRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.put(`${API_BASE_URL}/api/backoffice/tag/${id}`, request, callback, errCallback);
    }

    public static editContentList = (id: string, request: EditContentListRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.put(`${API_BASE_URL}/api/backoffice/content-lists/${id}`, request, callback, errCallback);
    }

    public static getAwardList = (callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/award/list`, callback, errCallback);
    }

    public static createAward = (request: CreateAwardRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.post(`${API_BASE_URL}/api/backoffice/award`, request, callback, errCallback);
    }

    public static deleteAward = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.deleteEmptyResponse(`${API_BASE_URL}/api/backoffice/award/${id}`, callback, errCallback);
    }

    public static getAwardListPaginated = (queryParams: Array<[string, any]> | null = null, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/award/paginated-list`, callback, errCallback, queryParams);
    }

    public static editAward = (id: string, request: EditAwardRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.put(`${API_BASE_URL}/api/backoffice/award/${id}`, request, callback, errCallback);
    }

    public static getFestivalList = (callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/festival/list`, callback, errCallback);
    }

    public static createFestival = (request: CreateFestivalRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.post(`${API_BASE_URL}/api/backoffice/festival`, request, callback, errCallback);
    }

    public static deleteFestival = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.deleteEmptyResponse(`${API_BASE_URL}/api/backoffice/festival/${id}`, callback, errCallback);
    }

    public static getFestivalListPaginated = (queryParams: Array<[string, any]> | null = null, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/festival/paginated-list`, callback, errCallback, queryParams);
    }

    public static editFestival = (id: string, request: EditFestivalRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.put(`${API_BASE_URL}/api/backoffice/festival/${id}`, request, callback, errCallback);
    }

    public static getGenreList = (callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/genre/list`, callback, errCallback);
    }

    public static createGenre = (request: CreateGenreRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.post(`${API_BASE_URL}/api/backoffice/genre`, request, callback, errCallback);
    }

    public static deleteGenre = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.deleteEmptyResponse(`${API_BASE_URL}/api/backoffice/genre/${id}`, callback, errCallback);
    }

    public static getGenreListPaginated = (queryParams: Array<[string, any]> | null = null, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/genre/paginated-list`, callback, errCallback, queryParams);
    }

    public static getSeriesListPaginated = (queryParams: Array<[string, any]> | null = null, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/series/paginated-list`, callback, errCallback, queryParams);
    }

    public static deleteSeries = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.delete(`${API_BASE_URL}/api/backoffice/series/${id}`, callback, errCallback);
    }

    public static editGenre = (id: string, request: EditGenreRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.put(`${API_BASE_URL}/api/backoffice/genre/${id}`, request, callback, errCallback);
    }

    public static getCountryList = (callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/country/list`, callback, errCallback);
    };

    public static createCountry = (request: CreateCountryRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.post(`${API_BASE_URL}/api/backoffice/country`, request, callback, errCallback);
    }

    public static deleteCountry = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.deleteEmptyResponse(`${API_BASE_URL}/api/backoffice/country/${id}`, callback, errCallback);
    }

    public static editCountry = (id: string, request: EditCountryRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.put(`${API_BASE_URL}/api/backoffice/country/${id}`, request, callback, errCallback);
    }

    public static getCountryListPaginated = (queryParams: Array<[string, any]> | null = null, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/country/paginated-list`, callback, errCallback, queryParams);
    }

    public static getMusicCueSheetList = (callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/musicCueSheet/list`, callback, errCallback);
    };

    public static getCollectionList = (callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/contents/get-collection-list`, callback, errCallback);
    };

    public static getContentById = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/contents/${id}`, callback, errCallback);
    }

    public static getSeriesById = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/series/${id}`, callback, errCallback);
    }

    public static getMusicCueSheetsListByContentId = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/contents/${id}/music-cue-sheet`, callback, errCallback);
    }

    public static getLanguageList = (callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/language/list`, callback, errCallback);
    };

    public static createLanguage = (request: CreateLanguageRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.post(`${API_BASE_URL}/api/backoffice/language`, request, callback, errCallback);
    }

    public static deleteLanguage = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.deleteEmptyResponse(`${API_BASE_URL}/api/backoffice/language/${id}`, callback, errCallback);
    }

    public static editLanguage = (id: string, request: EditLanguageRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.put(`${API_BASE_URL}/api/backoffice/language/${id}`, request, callback, errCallback);
    }

    public static getLanguageListPaginated = (queryParams: Array<[string, any]> | null = null, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/language/paginated-list`, callback, errCallback, queryParams);
    }

    public static getSingleContentList = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/content-lists/${id}`, callback, errCallback);
    };

    public static getCouponList = (callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/coupon/list`, callback, errCallback);
    }

    public static createCoupon = (request: CreateCouponRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.post(`${API_BASE_URL}/api/backoffice/coupon`, request, callback, errCallback);
    }

    public static deleteCoupon = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.deleteEmptyResponse(`${API_BASE_URL}/api/backoffice/coupon/${id}`, callback, errCallback);
    }

    public static getCouponListPaginated = (queryParams: Array<[string, any]> | null = null, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/coupon/paginated-list`, callback, errCallback, queryParams);
    }

    public static editCoupon = (id: string, request: EditCouponRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.put(`${API_BASE_URL}/api/backoffice/coupon/${id}`, request, callback, errCallback);
    }

    public static getSubscriptionsListPaginated = (queryParams: Array<[string, any]> | null = null, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/subscription/paginated-list`, callback, errCallback, queryParams);
    }

    public static deleteSubscription = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.deleteEmptyResponse(`${API_BASE_URL}/api/backoffice/subscription/${id}`, callback, errCallback);
    }

    public static createSubscription = (request: CreateSubscriptionRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.post(`${API_BASE_URL}/api/backoffice/subscription/`, request, callback, errCallback);
    };

    public static getSubscription = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/subscription/${id}`, callback, errCallback);
    };

    public static editSubscription = (id: string, request: any, callback: any, errCallback: any) => {
        ZPlayNetworkService.put(`${API_BASE_URL}/api/backoffice/subscription/${id}`, request, callback, errCallback);
    }

    public static approveContent = (id: string, request: ApproveContentRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.putEmptyResponse(`${API_BASE_URL}/api/backoffice/contents/${id}/approve-content`, request, callback, errCallback);
    }

    public static confirmThumbnailUploadContentList = (contentListId: any, callback: any, errCallback: any) => {
        ZPlayNetworkService.putEmptyResponse(`${API_BASE_URL}/api/backoffice/content-lists/${contentListId}/confirm-cover-upload`, {},
            callback, errCallback);
    };

    public static createContentsFromCSV = (base64File: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.post(`${API_BASE_URL}/api/backoffice/contents/csv`, { file: base64File }, callback, errCallback);
    };

    public static createSeries = (request: CreateSeriesRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.post(`${API_BASE_URL}/api/backoffice/series/`, request, callback, errCallback);
    };

}
